export const isMobile = () => {
  const ua = navigator.userAgent || navigator.vendor || window.opera;

  if (/android/i.test(ua)) {
    return true;
  }

  // iOS detection
  if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
    return true;
  }

  return false;
};